module.exports = __webpack_public_path__ + "static/media/Logo-icon-credit.84c7e8b1.png";